<template>
    <div class="root">
        <section class="comments" v-if="status === 'COMPLETED'">
            <div class="box" v-if="comments.length > 0">
                <article class="media" v-for="comment in comments" :key="comment.id">
                    <div class="media-content">
                        <div class="content">
                            <p>
                                <strong class="comment-author">{{ comment.author }}</strong>
                                <small>{{ comment.date.datetime }}</small>
                                <span class="tag type-tag" v-if="comment.type == 'INTERNAL'"
                                    >Internal</span
                                >
                                <span class="tag type-tag" v-if="comment.type == 'CONSUMER_RATING'"
                                    >Consumer Rating</span
                                >
                                <br />
                                <span class="comment-content">
                                    <span class="comment-message">{{ comment.message }}</span>
                                    <span
                                        class="tag rating-tag is-large is-danger"
                                        v-if="comment.rating === 1"
                                        >1</span
                                    >
                                    <span
                                        class="tag rating-tag is-large is-warning"
                                        v-if="comment.rating === 2"
                                        >2</span
                                    >
                                    <span
                                        class="tag rating-tag is-large is-warning"
                                        v-if="comment.rating === 3"
                                        >3</span
                                    >
                                    <span
                                        class="tag rating-tag is-large is-primary"
                                        v-if="comment.rating === 4"
                                        >4</span
                                    >
                                    <span
                                        class="tag rating-tag is-large is-success"
                                        v-if="comment.rating === 5"
                                        >5</span
                                    >
                                </span>
                            </p>
                        </div>
                    </div>
                </article>
            </div>
            <div class="notification no-comments" v-if="comments.length === 0">
                <h2 class="title is-3">No coments have yet been made on this route</h2>
            </div>
        </section>
        <section class="new-comment" v-if="status === 'COMPLETED'">
            <input
                class="new-comment-text input"
                type="text"
                placeholder="Write Comment"
                v-model="newComment"
            />
            <a class="button is-primary" @click="onCommentAdd" :disabled="newComment.length === 0"
                >ADD</a
            >
        </section>

        <section class="loading-comments" v-if="status === 'PRE'">
            <img src="@/assets/loading-dots.svg" />
        </section>
    </div>
</template>

<script>
import { Webapi } from '@/Webapi'

export default {
    name: 'RouteComments',
    data: () => ({
        routeId: null,
        status: 'PRE',
        comments: [],
        newComment: '',
    }),
    methods: {
        onCommentAdd() {
            const { routeId, newComment } = this.$data
            this.$data.newComment = ''
            Webapi().addComment(parseInt(routeId, 10), newComment).then(this.onDataReceieved)
        },
        onDataReceieved(response) {
            this.$data.status = response.status
            if (response.payload) {
                this.$data.comments = response.payload.sort(
                    (a, b) => new Date(b.date.iso) - new Date(a.date.iso),
                )
            }
        },
    },
    beforeMount() {
        this.$data.routeId = this.$route.params.id
        const { routeId } = this.$data
        Webapi().routeComments(routeId).then(this.onDataReceieved)
    },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';
.root {
    height: 100%;
    width: 100%;
    display: flex;
}

.comments {
    flex: 1;
    background-color: transparent;
    width: 100%;
    margin-bottom: 60px;
    padding: 10px;
}

.comment-author {
    margin-right: 10px;
}

.new-comment {
    position: fixed;
    bottom: 10px;
    left: 10px;
    right: 10px;
    height: 40px;
    display: flex;
    flex-direction: row;
}

.new-comment-text {
    flex: 1;
    margin-right: 10px;
}

.new-comment-add {
    width: 50px;
}

.loading-comments {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
}

.no-comments {
    padding-top: 100px;
    color: slategrey;
    width: 100%;
    display: flex;
    justify-content: center;
}

.type-tag {
    margin-left: 15px;
}

.comment-content {
    display: flex;
    justify-content: space-between;
}

.comment-message {
    padding-top: 5px;
}
</style>
